<template>
  <div class="container">
    <head-nav-bar
      title="会员列表"
      :fixed="true"
      rightText="筛选"
      @click-right="onSearchClick"
    >
    </head-nav-bar>
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入搜索关键词"
        style="border-bottom:1px solid #f1f1f1;"
        v-model="keyword"
        @search="onSearch"
        shape="round"
        show-action
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <data-list
        :api="getMemberList"
        :params="listParams"
        style="height:calc(100vh - 115px)"
      >
        <template v-slot:item="item">
          <van-swipe-cell style="min-height:66px;">
            <news-card
              :data="item"
              size="small"
              descField="Phone"
              @click="toInfo(item)"
            />
            <template slot="right">
              <!-- <van-button
                square
                type="info"
                style="height:100%;"
                text="编辑"
                :to="{ name: 'memberAdd', query: { Id: item.Id } }"
              /> -->
              <van-button
                square
                type="danger"
                style="height:100%;"
                text="删除"
                @click="del(item)"
              />
            </template>
          </van-swipe-cell>
        </template>
      </data-list>
    </div>
  </div>
</template>

<script>
import { getMemberList, getMemberTypeList, delMember } from "@/api/member.js";
import { getSelectData } from "@/api/common.js";

import searchPopup from "@/components/searchPopup";
import { SwipeCell, Button, Search } from "vant";
import DataList from "@/components/DataList";
import NewsCard from "@/components/NewsCard";

export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Search.name]: Search,
    DataList,
    NewsCard,
  },
  data() {
    return {
      getMemberList,
      listParams: {},
      keyword: "",
      memberTypeData: [],
      memberStatusData: [],
    };
  },
  created() {
    this.getSearchSelectData();
  },
  methods: {
    onSearchClick() {
      const that = this;
      searchPopup({
        title: "会员筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "会员状态",
            name: "IsContainInvalid",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
            },
            data: this.memberStatusData,
          },
          {
            label: "会员类型",
            name: "CardTypeId",
            type: "buttonSelect",
            props: {},
            data: this.memberTypeData,
          },
        ],
        submit: values => {
          that.handleSearch(values);
        },
      });
    },
    toInfo(item) {
      this.$router.push({
        name: "memberInfo",
        query: {
          Id: item.Id,
        },
      });
    },
    onSearch() {
      this.listParams = {
        Keyword: this.keyword,
      };
    },
    getSearchSelectData() {
      //获取会员类型
      getMemberTypeList({
        PageIndex: 0,
        PageSize: 1000,
        IsContainInvalid: false,
      }).then(res => {
        this.memberTypeData = res.Data.Datas;
      });
      //获取会员状态
      getSelectData({
        Types: "MemberCardStatus",
      }).then(res => {
        this.memberStatusData = res.Data.MemberCardStatus;
      });
    },
    handleSearch(values) {
      let isValid = true;
      if (values.IsContainInvalid && values.IsContainInvalid.length) {
        isValid = values.IsContainInvalid == "4" ? true : false;
      }
      this.listParams = {
        Keyword: this.keyword,
        IsContainInvalid: isValid,
        CardTypeId:
          values.CardTypeId && values.CardTypeId.length
            ? values.CardTypeId
            : undefined,
      };
    },
    del(item) {
      delMember({
        Id: item.Id,
      }).then(() => {
        this.onSearch();
      });
    },
  },
};
</script>
